// Filter option constants for Provider Experience Global Filters

import { DropdownOption } from '@src/CommonComponents/DynamicFilters';
import { LOB_OPTIONS } from '../../PemDetails/constant';
import { getSessionTimePeriod } from '../services/filterStateManager';

export const TIME_PERIOD_OPTIONS: DropdownOption[] = [];

export const setPemTimePeriodOptions = (options: DropdownOption[]): void => {
  TIME_PERIOD_OPTIONS.splice(0, TIME_PERIOD_OPTIONS.length, ...options);
};

/**
 * Returns the default time period value for initial payload.
 * Uses the same logic as onChange by calling getSessionTimePeriod().
 * Format: "01/01/2026 - 07/31/2026" for YTD, or "2025" for complete years.
 */
export const getDefaultTimePeriodValue = (): string => {
  const timePeriodOption = getSessionTimePeriod();
  return String(timePeriodOption?.value || '');
};

export const LOB_FILTER_OPTIONS: DropdownOption[] = LOB_OPTIONS.map((opt) => ({
  id: opt.value,
  value: opt.value,
  label: opt.title,
}));

export const TAX_ID_OPTIONS: DropdownOption[] = [
  { id: 'all', value: 'All', label: 'All' },
];

export const PROGRAM_OPTIONS: DropdownOption[] = [];

export const COMPARE_TO_OPTIONS: DropdownOption[] = [
  { id: 'lob', value: 'LOB', label: 'LOB' },
  { id: 'speciality', value: 'Speciality', label: 'Speciality' },
  { id: 'programs', value: 'Programs', label: 'Programs' },
  { id: 'adjudication-type', value: 'Adjudication Type', label: 'Adjudication Type' },
  { id: 'health-system', value: 'Health System', label: 'Health System' },
  { id: 'time-period', value: 'Time Period', label: 'Time Period' },
];

export const GEO_COMPARE_TO_OPTIONS: DropdownOption[] = [
  { id: 'region', value: 'Region', label: 'Region' },
  { id: 'states', value: 'States', label: 'States' },
  { id: 'markets', value: 'Markets', label: 'Markets' },
  ...COMPARE_TO_OPTIONS,
];

export const SPECIALITY_OPTIONS: DropdownOption[] = [];

export const FACILITY_TYPE_OPTIONS: DropdownOption[] = [
  { id: 'all', value: 'All', label: 'All' },
  { id: 'hospital', value: 'Hospital', label: 'Hospital' },
  { id: 'clinic', value: 'Clinic', label: 'Clinic' },
  { id: 'ambulatory', value: 'Ambulatory Surgical Center', label: 'Ambulatory Surgical Center' },
];

export const ADJUDICATION_TYPE_OPTIONS: DropdownOption[] = [];

export const REGION_OPTIONS: DropdownOption[] = [];

export const STATE_OPTIONS: DropdownOption[] = [];

export const MARKET_OPTIONS: DropdownOption[] = [];

export const COMPARE_VALUES_BY_TYPE: Record<string, DropdownOption[]> = {
  LOB: LOB_FILTER_OPTIONS,
  Speciality: SPECIALITY_OPTIONS,
  Programs: PROGRAM_OPTIONS,
  'Adjudication Type': ADJUDICATION_TYPE_OPTIONS,
  Region: REGION_OPTIONS,
  States: STATE_OPTIONS,
  Markets: MARKET_OPTIONS,
  'Health System': [],
  'Time Period': TIME_PERIOD_OPTIONS,
};
